import React from 'react';
import * as PropTypes from 'prop-types';
import { CheckIcon } from '@Components/UI/Icons';
import { useTranslation } from 'react-i18next';
import config from '@/config.json';
import {
  SectionItem,
  SectionItemIcon,
  SectionItemTxt,
  SectionItemHeadline,
  SectionItemTop,
} from './styled';

const MainScreenElement = ({ headline, text = null }) => {
  const { t } = useTranslation();
  const template = config.TEMPLATE;
  const brandName = config.DESCRIPTOR_NAME;
  const oldTemplate = ['oldTemplate'].includes(template);
  const useDarkTxt = config?.DESCRIPTOR_TAG === 'appups.info';

  const getCustomCheck = (() => {
    const colorMapping = {
      'PROTECT247.PRO': 'green',
      'PROTECT247.LIVE': 'green',
      'PROTECT247.SHOP': 'green',
      'PROTECT247.MOBI': 'green',
      'KIDGY.MOBI': 'green',
      'KIDGY.ONLINE': 'green',
      'KIDGY.SERVICES': 'green',
      'KIDGY.SHOP': 'green',
      'KIDGY.TOOLS': 'green',
      'SPOTTRACK.MOBI': 'green',
      'SPOTTRACK.ONLINE': 'green',
      'SPOTTRACK.PRO': 'green',
      'SPOTTRACK.INFO': 'green',
      'SPOTTRACK.SHOP': 'green',
      'SEARQLE.PRO': 'green',
      'SEARQLE.INFO': 'green',
      'SEARQLE.CLICK': 'green',
      'SEARQLE.SITE': 'green',
      'PROTECT247.LINK': 'blue',
      'SEARQLE.STORE': 'blue',
      'DAILY-MDH.PRO': 'green',
      'PLANMD-TP.PRO': 'green',
      'TOPPLAN.PRO': 'green',
      'TPLANMDT.PRO': 'green',
      'YOUMDPLN.PRO': 'green',
      'Y-MEDITN.PRO': 'green',
      'YRMDTN.PRO': 'green',
      'DLY-HLPR.PRO': 'green',
      'DAYHPR.PRO': 'green',
      'MUSTREADZ.ONLINE': 'green',
      'MUSTREADZ.SHOP': 'green',
      'MUSTREADZ.CFD': 'green',
      'MUSTREADZ.STORE': 'green',
      'MUSTREADZ.SITE': 'green',
      'MVIEW.APP': 'green',
      'MYCLIENTPANEL.INFO': 'green',
      'CLIENTPANEL.INFO': 'green',
      'WEBKITTAPP.COM': 'green',
      'WEMANAGEKIT.INFO': 'green',
      'SERVS.APP': 'green',
      'HBOPRIMEVIDEO.INFO': 'green',
      'PARAMAUNTLIVE.LIVE': 'green',
      'DISCOWERYCHNL.SPACE': 'green',
      'YOURMEDITATIONPLAN.CFD': 'green',
      'TOP-MEDITATION-PLAN.SBS': 'green',
      'HEALTH-MEDITATION.ONLINE': 'green',
      'MSPY.FYI': 'green',
      'MDGUIDE4U.FYI': 'green',
      'VL.BLLX.CC': 'green',
      'VNL.BLLX.CC': 'green',
      'VP.BLLX.CC': 'green',
      'VNP.BLLX.CC': 'green',
      'VR.BLLX.CC': 'green',
      'VNR.BLLX.CC': 'green',
      'VI.BLLX.CC': 'green',
      'VINR.BLLX.CC': 'green',
      'VRR.BLLX.CC': 'green',
      'GPF.SBSCRIL.CC': 'green',
      'GPTF.SBSCRIL.CC': 'green',
      'GRP.SBSCRIL.CC': 'green',
      'GRPT.SBSCRIL.CC': 'green',
      'GRPF.SBSCRIL.CC': 'green',
      'DLM.SBSCRIL.CC': 'green',
      'DH.SBSCRIL.CC': 'green',
      'DM.SBSCRIL.CC': 'green',
      'DMH.SBSCRIL.CC': 'green',
      'DLMH.SBSCRIL.CC': 'green',
      'HL.SBSCRIL.CC': 'green',
      'HM.SBSCRIL.CC': 'green',
      'HLM.SBSCRIL.CC': 'green',
      'HTM.SBSCRIL.CC': 'green',
      'HLT.SBSCRIL.CC': 'green',
      'MSP.BLLX.CC': 'green',
      'TRCK.BLLX.CC': 'green',
      'MDTN.BLLX.CC': 'green',
      'TRSP.BLLX.CC': 'green',
      'SPTR.BLLX.CC': 'green',
      'MNP.BLLX.CC': 'green',
      'MSPC.BLLX.CC': 'green',
      'VNLP.PRO': 'green',
      'MYKIDSGUARD.CFD': 'green',
      'KIDSECURED.ONLINE': 'green',
    };
    return colorMapping[brandName] || '';
  })();

  return (
    <SectionItem className={oldTemplate && template}>
      <SectionItemTop className={oldTemplate && template}>
        <SectionItemIcon id={getCustomCheck} className={oldTemplate && template}>
          <CheckIcon template={template} />
        </SectionItemIcon>
        <SectionItemHeadline
          className={oldTemplate && template}
          dangerouslySetInnerHTML={{
            __html: t(`${headline}`),
          }}
          useDarkTxt={useDarkTxt}
        />
      </SectionItemTop>
      {text !== null && <SectionItemTxt>{t(`${text}`)}</SectionItemTxt>}
    </SectionItem>
  );
};

MainScreenElement.propTypes = {
  headline: PropTypes.string.isRequired,
  text: PropTypes.string,
};

export default MainScreenElement;
